const parseDecAddress = function(addr, radix) {
   const res = parseInt(addr, radix)

   return 0 <= res && 0xffffffff >= res ? res : NaN
}

const parseHexAddress = function(addr) {
   let sides = addr.split(/::+/),
      left = sides.slice(0, sides.length - 1).join(':').split(':').filter(x => '' !== x),
      right = sides[sides.length - 1].split(':').filter(x => '' !== x),
      results = ['0', '0', '0', '0']

   if (4 < left.length + right.length) {
      return NaN
   }

   let offset = 0 <= right.length ? 0 : results.length - left.length

   for (let i = 0; i < left.length; i = i + 1) {
      results[offset + i] = left[i]
   }

   let n = results.length

   for (let i = right.length - 1; 0 <= i; i--) {
      n = n - 1
      results[n] = right[i]
   }

   for (n = 0; n < results.length; n++) {
      results[n] = parseInt(results[n], 16)

      if (isNaN(results[n]) || 0 > results[n] || 0xff < results[n]) {
         return NaN
      }
   }

   return (results[0] << 24) + (results[1] << 16) + (results[2] << 8) + results[3]
}

const parseBinAddress = function(addr) {
   let parts = ['0', '0', '0', '0'].concat(addr.split('.')).filter(x => '' !== x).slice(-4)

   for (let i = 0; i < parts.length; i++) {
      parts[i] = parseInt(parts[i], 10)

      if (isNaN(parts[i]) || 0 > parts[i] || 0xff < parts[i]) {
         return NaN
      }
   }

   return (parts[0] << 24) + (parts[1] << 16) + (parts[2] << 8) + parts[3]
}

export const parse = function(addr) {
   if (!addr) {
      return NaN
   }
   let addr2 = addr.toString()

   if (addr2.match(/^[0-9]*$/)) {
      return parseDecAddress(addr2, 10)
   } else if (addr2.match(/^[0-9:a-fA-F]*$/)) {
      return parseHexAddress(addr2)
   } else if (addr2.match(/^[0-9.]*$/)) {
      return parseBinAddress(addr2)
   } else if (addr2.match(/^[0-9A-Z]*$/)) {
      return parseDecAddress(addr2, 36)
   }

   return NaN
}



// WEBPACK FOOTER //
// lib/util/address.js